import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';

import ChatIcon from '@material-ui/icons/Chat';

import useApi from 'app/context/useApi';
import useApp from 'app/context/useApp';

const useStyles = makeStyles(theme => ({
    commentContainer: {
        paddingTop: theme.spacing(2)
    },
    commentFlex: {
        display: 'flex',
        alignItems: 'center'
    },
    commentColOne: {
        flexGrow: 0,
        minWidth: 60
    },
    commentColTwo: {
        flexGrow: 1
    },
    commentColThree: {
        flexGrow: 0,
        minWidth: 60,
        textAlign: 'right'
    }
}));

const initValues = {
    id: 0,
    message: '',
}

export default function EditComment(props) {

    const { app } = useApp();
    const api = useApi();

    const { comment, commentableType, commentableId, onComment } = props;
    const classes = useStyles();

    const [ values, setValues ] = useState(initValues);

    const [ errors, setErrors ] = useState({});
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        if (comment) {
            const keys = Object.keys(initValues);
            const newValues = {};
            for (const key of keys) {
                if (comment[key] !== null) {
                    newValues[key] = comment[key];
                }
            }
            setValues(newValues);
        }
    }, [comment]);

    const handleMessage = e => {
        const value = e.target.value;

        if (isError('message')) delete errors.message;

        setValues({ ...values, message: value });
    };

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            postComment();
        }
    }

    const postComment = () => {
        setLoading(true);

        api.post(`/comment/${commentableType}/${commentableId}/${values.id}`, values)
            .then(res => {
                onComment();
                clearComment();
            }).catch(error => {
                setLoading(false);
                if (error?.response?.data?.errors) {
                    setErrors(error.response.data.errors)
                }
            });
    }

    const isError = field => {
        if (errors[field]) return true;
        return false;
    };

    const getErrorMessage = field => {
        if (isError(field)) return errors[field];
        return "";
    };

    const clearComment = () => {
        setValues(initValues);
        setErrors({});
        setLoading(false);
    }

    return (
        <div className={classes.commentContainer}>
            <div className={classes.commentFlex}>
                <div className={classes.commentColOne}>
                    <Avatar
                        aria-label={app.user.full_name}
                        alt={app.user.full_name}
                        className={classes.avatar}
                        src={app.user.avatar ? app.user.avatar.full_url : null}
                        >
                        {app.user.initials}
                    </Avatar>
                </div>
                <div className={classes.commentColTwo}>
                    <TextField
                        label="Comment"
                        name="message"
                        value={values.message}
                        onChange={handleMessage}
                        onKeyPress={handleKeyPress}
                        fullWidth
                        error={isError('message')}
                        helperText={getErrorMessage('message')}
                        variant="outlined"
                        multiline
                        rows="1"
                        rowsMax="4"
                        size="small"
                        color="secondary"
                        inputProps={{
                            maxLength: "255"
                        }}
                    />
                </div>
                <div className={classes.commentColThree}>
                    <IconButton onClick={postComment} aria-label="Post Comment" color="secondary">
                        <ChatIcon />
                    </IconButton>
                </div>
            </div>
        </div>
    )
}
